import SimpleBar from "simplebar";

const form = document.querySelector("form"),
  submit = document.querySelector('[type="submit"]');

export const formScrollerInit = () => {
  const scroller = document.querySelector(".form__scroller");
  if (scroller !== null) {
    new SimpleBar(scroller, {
      autoHide: false,
    });
  }
};

export const uploadFileOutput = () => {
  const inputFiles = document.querySelectorAll('input[type="file"]');
  inputFiles?.forEach((file) => {
    file.addEventListener("change", () => {
      const upload = file.files[0];
      const parentElem = file.closest(".form__input");
      const outputArea = parentElem.querySelector(".file__name");

      if (upload) {
        outputArea.innerText = upload.name;
      } else {
        outputArea.innerText = "選択されていません";
      }
    });
  });

  const mwInputFiles = document.querySelectorAll(".mw-wp-form_file");
  mwInputFiles?.forEach((file) => {
    const value = file.querySelector("input").value;
    const parentElem = file.closest(".form__input");
    const outputArea = parentElem.querySelector(".file__name");

    outputArea.innerText = value;
  });
};

export const submitAfterDisabled = () => {
  if (form) {
    form.addEventListener("submit", () => {
      submit.disabled = true;
    });
  }
};

export const formValidate = (postData) => {
  if (form) {
    const errorClassName = ["form__error", "text", "text--small"];

    const requiredElems = document.querySelectorAll(".js-required input,.js-required select,.js-required textarea"),
      emailElems = document.querySelectorAll(".js-email input"),
      telElems = document.querySelectorAll(".js-tel input"),
      maxlengthElems = document.querySelectorAll(".js-maxlength input,.js-maxlength textarea");

    const createError = (el, errorMessage) => {
      const errorDiv = document.createElement("div");
      errorDiv.classList.add(...errorClassName);
      errorDiv.textContent = errorMessage;
      el.parentNode.appendChild(errorDiv);
    };

    const validateRequired = () => {
      let hasError = false;
      requiredElems.forEach((elem) => {
        if (elem.tagName === "INPUT" && elem.getAttribute("type") === "checkbox") {
          const checked = elem.parentElement.querySelector('input[type="checkbox"]:checked');

          if (checked === null) {
            //エラーを表示
            createError(elem, "入力してください。");
            hasError = true;
          }
        } else {
          const elemValue = elem.value.trim();

          if (elemValue.length === 0) {
            if (elem.tagName === "SELECT") {
              createError(elem, "入力してください。");
            } else {
              createError(elem, "入力してください。");
            }
            hasError = true;
          }
        }
      });
      return hasError;
    };

    const validateEmail = () => {
      let hasError = false;
      const pattern = /^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/iu;
      emailElems.forEach((elem) => {
        if (elem.value !== "" && !pattern.test(elem.value)) {
          createError(elem, "メールアドレスを入力してください。");
          hasError = true;
        }
      });
      return hasError;
    };

    const validateTel = () => {
      let hasError = false;
      const pattern = /^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/;
      telElems.forEach((elem) => {
        if (elem.value !== "" && !pattern.test(elem.value)) {
          createError(elem, "電話番号を入力してください。");
          hasError = true;
        }
      });
      return hasError;
    };

    const validateMaxlength = () => {
      let hasError = false;
      maxlengthElems.forEach((elem) => {
        const maxlength = elem.hasAttribute("data-maxlength") ? elem.dataset.maxlength : 1000;
        if (elem.value !== "" && elem.value.length > maxlength) {
          createError(elem, maxlength + "文字以内でご入力ください");
          hasError = true;
        }
      });
      return hasError;
    };

    form.addEventListener("submit", (e) => {
      const errorElems = form.querySelectorAll("." + errorClassName[0]);
      errorElems.forEach((elem) => {
        elem.remove();
      });

      const hasRequiredError = validateRequired();
      const hasEmailError = validateEmail();
      const hasTelError = validateTel();
      const hasMaxlengthError = validateMaxlength();

      if (hasRequiredError || hasEmailError || hasTelError || hasMaxlengthError) {
        e.preventDefault();
        if (postData !== undefined) {
          postData();
        }
      } else {
        submit.disabled = true;
      }
    });
  }
};
